var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDefaultAvatar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32.0547,
  cy: 32.4121,
  r: 32,
  fill: "#95AAC9"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32.0542 17.8806C28.5677 17.8806 25.7437 20.7046 25.7437 24.1912C25.7437 27.6778 28.5677 30.5018 32.0542 30.5018C35.5408 30.5018 38.3648 27.6778 38.3648 24.1912C38.3648 20.7046 35.5408 17.8806 32.0542 17.8806ZM32.0542 33.657C27.8419 33.657 19.4331 35.7711 19.4331 39.9676V43.1229H44.6754V39.9676C44.6754 35.7711 36.2665 33.657 32.0542 33.657Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-avatar.e0f15527798ae0b8c597b03c90aa13c7.svg";